import { createContext, useContext } from 'react';
import type { DraggableSyntheticListeners } from '@dnd-kit/core';

interface Context {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  attributes: Record<string, any>;
  listeners: DraggableSyntheticListeners;
  draggableNodeRef(node: HTMLElement | null): void;
}

export const SortableItemContext = createContext<Context>({
  attributes: {},
  listeners: undefined,
  draggableNodeRef() {},
});

export const useSortableItemContext = () => {
  const context = useContext(SortableItemContext);
  if (context === undefined) {
    throw new Error('useSortableItemContext must be used within a SortableItemContext.Provider');
  }
  return context;
};
